/** Entries for the project settings search box. */
export const collectionSettingsIndex = [
  {
    label: "Open collection (many records per prompt)",
    tab: "Collection",
    path: "/collection",
    keywords:
      "collect data collection gather photos recordings sentences as many as you can submit and next repeat same prompt open prompt field data crowdsource contributions",
  },
  {
    label: "Goal and limits per contributor",
    tab: "Collection",
    path: "/collection",
    keywords: "goal target quota limit maximum per person per contributor how many records cap total per prompt close",
  },
  {
    label: "Editing saved records",
    tab: "Collection",
    path: "/collection",
    keywords: "edit delete change record after submit until reviewed 24 hours lock contributor",
  },
  {
    label: "Project type: annotate or collect data",
    tab: "Collection",
    path: "/collection",
    keywords: "project type kind annotate collect data gather purpose",
  },
];
